import { render, staticRenderFns } from "./CommandsList.vue?vue&type=template&id=2cf60d82&scoped=true&lang=pug&"
import script from "./CommandsList.vue?vue&type=script&lang=js&"
export * from "./CommandsList.vue?vue&type=script&lang=js&"
import style0 from "./CommandsList.vue?vue&type=style&index=0&id=2cf60d82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf60d82",
  null
  
)

export default component.exports